// extracted by mini-css-extract-plugin
export var contact = "index-module--contact--41883";
export var content = "index-module--content--ec461";
export var description = "index-module--description--94d9f";
export var recruit = "index-module--recruit--8955d";
export var root = "index-module--root--adef8";
export var subTitle = "index-module--subTitle--f8552";
export var title = "index-module--title--f7a1e";